<template>

  <div class="container">
    <section v-if="errored">
      <error :code=errorCode :message=errorMessage></error>
      <p class="mb-5"><router-link :to="{ name:'timeline' }">{{ $t("timeline_return") }}</router-link></p>
    </section>

    <section v-else>

      <div class="row" id="stream">

        <div class="col-lg-8 mt-0">
            <h2 class="h3">{{ stream.name }}</h2>
            <p class="ontario-lead-statement">{{ stream.description }}</p>
            <p class="mb-0"><router-link :to="{ name:'timeline' }">{{ $t("timeline_return") }}</router-link></p>
        </div><!-- col-lg-8 -->
      
        <hr class="bold_hr_super ml-3 mr-3">

      </div><!-- row -->
      
      <div class="row">

        <div class="col-lg-4">

          <h3 class="h4">{{ $t("timeline_stream_highlights") }}:</h3>
          <ul class="pl-4">
              <li class="mb-4" v-for="(fact, index) in stream.facts" v-bind:key="index" v-html="fact.content_name"></li>
          </ul>

          <hr>

          <h3 class="h4">{{ $t("timeline_stream_url") }}</h3>
          <p class="font-weight-bold mb-5 ut-su"><a v-bind:href="url">{{ url }}</a></p>

        </div><!-- col-lg-4 -->

        <div class="col-lg-7 offset-lg-1 padding-large-0">
          <streams></streams>
        </div><!-- col-lg-8 -->

      </div><!-- row -->

    </section>

  </div>

</template>

<script>
import Streams from '../components/Streams.vue'
import Error from '../components/Error.vue'
export default {
  components: {
    Streams,
    Error
  },
  data () {
    return {
      stream: [],
      loading: false,
      errored: false,
      errorCode: null,
      errorMessage: null,
      url: null
    }
  },
  methods: {
    fetchStreamData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'streams/' + this.$route.params.stream_id + '?language=' + this.$root.$i18n.locale)
        .then(response => {
          this.stream = response.data.data,
          this.url = this.stream.link
        })
        .catch(error => {
          this.setErrorVariables(error.response.status, error.response.data.message)
        })
        .finally(() => (
          this.loading = false
        ))
    },
    setErrorVariables (code, message) {
      this.errored = true
      this.errorCode = code
      this.errorMessage = message
    }
  },
  mounted () {
    this.fetchStreamData()
  }
}
</script>
